<template>
  <div id="emtions">
    <ul>
      <li v-for="(v,i) in emtions" :key="i" >
        <img :src="v.src" alt @click="selectFun(v.name,v.src,v.nickname)" :title="v.sname"/>
      </li>
    </ul>
  </div>
</template>

<script>
// 引入总线
import bus from "@/tool/bus";
export default {
  data() {
    return {
    emtions: [
        {
          name: "#[微笑]#",
          src: require("./emoji/weixiao.png"),
          nickname:'[困了]',
          sname:'[困了]'
        },
        {
          name: "#[撇嘴]#",
          src: require("./emoji/piezui.png"),
          nickname:'[捂嘴]',
          sname:'[捂嘴]'

        },
        {
          name: "#[色]#",
          src: require("./emoji/se.png"),
          nickname:'[面无表情]',
          sname:'[面无表情]'
          
        },
        {
          name: "#[发呆]#",
          src: require("./emoji/fadai.png"),
          nickname:'[乱七八糟]',
          sname:'[乱七八糟]'

        },
        // {
        //   name: "#[得意]#",
        //   src: require("./emoji/deyi.png"),
        //   nickname:'[喜笑颜开]'
        // },
        // {
        //   name: "#[流泪]#",
        //   src: require("./emoji/liulei.png"),
        //   nickname:'[拥抱]'
        // },
        {
          name: "#[害羞]#",
          src: require("./emoji/haixiu.png"),
          nickname:'[吐舌]',
          sname:'[吐舌]'

        },
        {
          name: "#[关嘴]#",
          src: require("./emoji/bizui.png"),
          nickname:'[喜极而泣]',
          sname:'[喜极而泣]'

        },
        {
          name: "#[睡]#",
          src: require("./emoji/shui.png"),
          nickname:'[安静]',
          sname:'[安静]'

        },
        {
          name: "#[大哭]#",
          src: require("./emoji/daku.png"),
          nickname:'[心动]',
          sname:'[心动]'

        },
        {
          name: "#[尴尬]#",
          src: require("./emoji/ganga.png"),
          nickname:'[亲亲]',
          sname:'[亲亲]'

        },
        {
          name: "#[发怒]#",
          src: require("./emoji/fanu.png"),
          nickname:'[无奈]',
          sname:'[无奈]'

        },
        {
          name: "#[调皮]#",
          src: require("./emoji/diaopi.png"),
          nickname:'[飞吻]',
          sname:'[飞吻]'

        },
        {
          name: "#[呲牙]#",
          src: require("./emoji/ciya.png"),
          nickname:'[可爱]',
          sname:'[可爱]'

        },
        {
          name: "#[惊讶]#",
          src: require("./emoji/jingya.png"),
          nickname:'[困惑]',
          sname:'[困惑]'

        },
        {
          name: "#[难过]#",
          src: require("./emoji/nanguo.png"),
          nickname:'[思考]',
          sname:'[思考]'

        },
        // {
        //   name: "#[酷]#",
        //   src: require("./emoji/ku.png"),
        //   nickname:'[光环]'
        // },
        {
          name: "#[冷汗]#",
          src: require("./emoji/lenghan.png"),
          nickname:'[悲伤]',
          sname:'[悲伤]'

        },
        {
          name: "#[抓狂]#",
          src: require("./emoji/zhuakuang.png"),
          nickname:'[篮球]',
          sname:'[篮球]'

        },
        {
          name: "#[吐]#",
          src: require("./emoji/tu.png"),
          nickname:'[吃惊]',
          sname:'[吃惊]'
          
        },
        {
          name: "#[偷笑]#",
          src: require("./emoji/touxiao.png"),
          nickname:'[痛苦]',
          sname:'[痛苦]'

        },
        {
          name: "#[可爱]#",
          src: require("./emoji/keai.png"),
          nickname:'[失望]',
          sname:'[失望]'

        },
        {
          name: "#[翻眼]#",
          src: require("./emoji/baiyan.png"),
          nickname:'[眯眼笑]',
          sname:'[眯眼笑]'

        },
        {
          name: "#[傲慢]#",
          src: require("./emoji/aoman.png"),
          nickname:'[咧嘴笑]',
          sname:'[咧嘴笑]'

        },
        {
          name: "#[饥饿]#",
          src: require("./emoji/jie.png"),
          nickname:'[忧郁]',
          sname:'[忧郁]'

        },
        {
          name: "#[困倦]#",
          src: require("./emoji/kun.png"),
          nickname:'[焦虑]',
          sname:'[焦虑]'

        },
        {
          name: "#[惊恐]#",
          src: require("./emoji/jingkong.png"),
          nickname:'[担心]',
          sname:'[担心]'

        },
        {
          name: "#[流汗]#",
          src: require("./emoji/liuhan.png"),
          nickname:'[流汗]',
          sname:'[流汗]'

        },
        {
          name: "#[憨笑]#",
          src: require("./emoji/hanxiao.png"),
          nickname:'[皮了]',
          sname:'[皮了]'

        },
        {
          name: "#[大兵]#",
          src: require("./emoji/dabing.png"),
          nickname:'[嘻嘻]',
          sname:'[嘻嘻]'

        },
        {
          name: "#[奋斗]#",
          src: require("./emoji/fendou.png"),
          nickname:'[么么]',
          sname:'[么么]'

        },
        {
          name: "#[咒骂]#",
          src: require("./emoji/zhouma.png"),
          nickname:'[足球]',
          sname:'[足球]'

        },
        {
          name: "#[疑问]#",
          src: require("./emoji/yiwen.png"),
          nickname:'[便便]',
          sname:'[便便]'

        },
        {
          name: "#[嘘]#",
          src: require("./emoji/xu.png"),
          nickname:'[闭嘴]',
          sname:'[闭嘴]'

        },
        {
          name: "#[晕]#",
          src: require("./emoji/yun.png"),
          nickname:'[见钱眼开]',
          sname:'[见钱眼开]'

        },
        {
          name: "#[折磨]#",
          src: require("./emoji/zhemo.png"),
          nickname:'[强]',
          sname:'[强]'

        },
        {
          name: "#[衰]#",
          src: require("./emoji/shuai.png"),
          nickname:'[囧]',
          sname:'[囧]'

        },
        {
          name: "#[骷髅]#",
          src: require("./emoji/kulou.png"),
          nickname:'[惧怕]',
          sname:'[惧怕]'

        },
        {
          name: "#[敲打]#",
          src: require("./emoji/qiaoda.png"),
          nickname:'[嘘哦]',
          sname:'[嘘]'

        },
        {
          name: "#[再见]#",
          src: require("./emoji/zaijian.png"),
          nickname:'[牛仔]',
          sname:'[牛仔]'

        },
        {
          name: "#[擦汗]#",
          src: require("./emoji/cahan.png"),
          nickname:'[大笑]',
          sname:'[大笑]'

        },
        {
          name: "#[抠鼻]#",
          src: require("./emoji/koubi.png"),
          nickname:'[眨眼]',
          sname:'[眨眼]'

        },
        {
          name: "#[鼓掌]#",
          src: require("./emoji/guzhang.png"),
          nickname:'[饥渴]',
          sname:'[饥渴]'

        },
        {
          name: "#[糗大了]#",
          src: require("./emoji/qiudale.png"),
          nickname:'[傻笑]',
          sname:'[傻笑]'

        },
        // {
        //   name: "#[坏笑]#",
        //   src: require("./emoji/huaixiao.png"),
        //   nickname:'[眼冒金星]'
        // },
        {
          name: "#[左哼哼]#",
          src: require("./emoji/zuohengheng.png"),
          nickname:'[国旗]',
          sname:'[国旗]'

        },
        {
          name: "#[右哼哼]#",
          src: require("./emoji/youhengheng.png"),
          nickname:'[感冒]',
          sname:'[感冒]'

        },
        {
          name: "#[哈欠]#",
          src: require("./emoji/haqian.png"),
          nickname:'[生气]',
          sname:'[生气]'

        },
        {
          name: "#[鄙视]#",
          src: require("./emoji/bishi.png"),
          nickname:'[怕怕]',
          sname:'[怕怕]'

        },
        {
          name: "#[委屈]#",
          src: require("./emoji/weiqu.png"),
          nickname:'[睡了]',
          sname:'[睡了]'

        },
        {
          name: "#[快哭了]#",
          src: require("./emoji/kuaikule.png"),
          nickname:'[惊恐]',
          sname:'[惊恐]'

        },
        {
          name: "#[阴险]#",
          src: require("./emoji/yinxian.png"),
          nickname:'[恶魔]',
          sname:'[恶魔]'

        },
        {
          name: "#[亲亲]#",
          src: require("./emoji/qinqin.png"),
          nickname:'[白眼]',
          sname:'[白眼]'

        },
        {
          name: "#[吓]#",
          src: require("./emoji/xia.png"),
          nickname:'[晕啊]',
          sname:'[晕]'

        },
        {
          name: "#[可怜]#",
          src: require("./emoji/kelian.png"),
          nickname:'[嫌弃]',
          sname:'[嫌弃]'

        }
      ]
      // emtions: [
      //   {
      //     name: "#[微笑]#",
      //     src: require("./emoji/weixiao.png"),
      //     nickname:'[困]'
      //   },
      //   {
      //     name: "#[撇嘴]#",
      //     src: require("./emoji/piezui.png"),
      //     nickname:'[捂嘴]'
      //   },
      //   {
      //     name: "#[色]#",
      //     src: require("./emoji/se.png"),
      //     nickname:'[面无表情]'
      //   },
      //   {
      //     name: "#[发呆]#",
      //     src: require("./emoji/fadai.png"),
      //     nickname:'[乱七八糟]'
      //   },
      //   // {
      //   //   name: "#[得意]#",
      //   //   src: require("./emoji/deyi.png"),
      //   //   nickname:'[喜笑颜开]'
      //   // },
      //   // {
      //   //   name: "#[流泪]#",
      //   //   src: require("./emoji/liulei.png"),
      //   //   nickname:'[拥抱]'
      //   // },
      //   {
      //     name: "#[害羞]#",
      //     src: require("./emoji/haixiu.png"),
      //     nickname:'[吐舌]'
      //   },
      //   {
      //     name: "#[闭嘴]#",
      //     src: require("./emoji/bizui.png"),
      //     nickname:'[喜极而泣]'
      //   },
      //   {
      //     name: "#[睡]#",
      //     src: require("./emoji/shui.png"),
      //     nickname:'[安静]'
      //   },
      //   {
      //     name: "#[大哭]#",
      //     src: require("./emoji/daku.png"),
      //     nickname:'[心动]'
      //   },
      //   {
      //     name: "#[尴尬]#",
      //     src: require("./emoji/ganga.png"),
      //     nickname:'[亲亲]'
      //   },
      //   {
      //     name: "#[发怒]#",
      //     src: require("./emoji/fanu.png"),
      //     nickname:'[无奈]'
      //   },
      //   {
      //     name: "#[调皮]#",
      //     src: require("./emoji/diaopi.png"),
      //     nickname:'[飞吻]'
      //   },
      //   {
      //     name: "#[呲牙]#",
      //     src: require("./emoji/ciya.png"),
      //     nickname:'[可爱]'
      //   },
      //   {
      //     name: "#[惊讶]#",
      //     src: require("./emoji/jingya.png"),
      //     nickname:'[困惑]'
      //   },
      //   {
      //     name: "#[难过]#",
      //     src: require("./emoji/nanguo.png"),
      //     nickname:'[思考]'
      //   },
      //   // {
      //   //   name: "#[酷]#",
      //   //   src: require("./emoji/ku.png"),
      //   //   nickname:'[光环]'
      //   // },
      //   {
      //     name: "#[冷汗]#",
      //     src: require("./emoji/lenghan.png"),
      //     nickname:'[悲伤]'
      //   },
      //   {
      //     name: "#[抓狂]#",
      //     src: require("./emoji/zhuakuang.png"),
      //     nickname:'[篮球]'
      //   },
      //   {
      //     name: "#[吐]#",
      //     src: require("./emoji/tu.png"),
      //     nickname:'[惊讶]'
      //   },
      //   {
      //     name: "#[偷笑]#",
      //     src: require("./emoji/touxiao.png"),
      //     nickname:'[痛苦]'
      //   },
      //   {
      //     name: "#[可爱]#",
      //     src: require("./emoji/keai.png"),
      //     nickname:'[失望]'
      //   },
      //   {
      //     name: "#[白眼]#",
      //     src: require("./emoji/baiyan.png"),
      //     nickname:'[眯眼笑]'
      //   },
      //   {
      //     name: "#[傲慢]#",
      //     src: require("./emoji/aoman.png"),
      //     nickname:'[咧嘴笑]'
      //   },
      //   {
      //     name: "#[饥饿]#",
      //     src: require("./emoji/jie.png"),
      //     nickname:'[忧郁]'
      //   },
      //   {
      //     name: "#[困]#",
      //     src: require("./emoji/kun.png"),
      //     nickname:'[焦虑]'
      //   },
      //   {
      //     name: "#[惊恐]#",
      //     src: require("./emoji/jingkong.png"),
      //     nickname:'[担心]'
      //   },
      //   {
      //     name: "#[流汗]#",
      //     src: require("./emoji/liuhan.png"),
      //     nickname:'[流汗]'
      //   },
      //   {
      //     name: "#[憨笑]#",
      //     src: require("./emoji/hanxiao.png"),
      //     nickname:'[调皮]'
      //   },
      //   {
      //     name: "#[大兵]#",
      //     src: require("./emoji/dabing.png"),
      //     nickname:'[嘻嘻]'
      //   },
      //   {
      //     name: "#[奋斗]#",
      //     src: require("./emoji/fendou.png"),
      //     nickname:'[么么]'
      //   },
      //   {
      //     name: "#[咒骂]#",
      //     src: require("./emoji/zhouma.png"),
      //     nickname:'[足球]'
      //   },
      //   {
      //     name: "#[疑问]#",
      //     src: require("./emoji/yiwen.png"),
      //     nickname:'[便便]'
      //   },
      //   {
      //     name: "#[嘘]#",
      //     src: require("./emoji/xu.png"),
      //     nickname:'[闭嘴]'
      //   },
      //   {
      //     name: "#[晕]#",
      //     src: require("./emoji/yun.png"),
      //     nickname:'[见钱眼开]'
      //   },
      //   {
      //     name: "#[折磨]#",
      //     src: require("./emoji/zhemo.png"),
      //     nickname:'[强]'
      //   },
      //   {
      //     name: "#[衰]#",
      //     src: require("./emoji/shuai.png"),
      //     nickname:'[囧]'
      //   },
      //   {
      //     name: "#[骷髅]#",
      //     src: require("./emoji/kulou.png"),
      //     nickname:'[惧怕]'
      //   },
      //   {
      //     name: "#[敲打]#",
      //     src: require("./emoji/qiaoda.png"),
      //     nickname:'[嘘]'
      //   },
      //   {
      //     name: "#[再见]#",
      //     src: require("./emoji/zaijian.png"),
      //     nickname:'[牛仔]'
      //   },
      //   {
      //     name: "#[擦汗]#",
      //     src: require("./emoji/cahan.png"),
      //     nickname:'[大笑]'
      //   },
      //   {
      //     name: "#[抠鼻]#",
      //     src: require("./emoji/koubi.png"),
      //     nickname:'[眨眼]'
      //   },
      //   {
      //     name: "#[鼓掌]#",
      //     src: require("./emoji/guzhang.png"),
      //     nickname:'[饥饿]'
      //   },
      //   {
      //     name: "#[糗大了]#",
      //     src: require("./emoji/qiudale.png"),
      //     nickname:'[傻笑]'
      //   },
      //   // {
      //   //   name: "#[坏笑]#",
      //   //   src: require("./emoji/huaixiao.png"),
      //   //   nickname:'[眼冒金星]'
      //   // },
      //   {
      //     name: "#[左哼哼]#",
      //     src: require("./emoji/zuohengheng.png"),
      //     nickname:'[国旗]'
      //   },
      //   {
      //     name: "#[右哼哼]#",
      //     src: require("./emoji/youhengheng.png"),
      //     nickname:'[感冒]'
      //   },
      //   {
      //     name: "#[哈欠]#",
      //     src: require("./emoji/haqian.png"),
      //     nickname:'[生气]'
      //   },
      //   {
      //     name: "#[鄙视]#",
      //     src: require("./emoji/bishi.png"),
      //     nickname:'[冷汗]'
      //   },
      //   {
      //     name: "#[委屈]#",
      //     src: require("./emoji/weiqu.png"),
      //     nickname:'[睡了]'
      //   },
      //   {
      //     name: "#[快哭了]#",
      //     src: require("./emoji/kuaikule.png"),
      //     nickname:'[惊恐]'
      //   },
      //   {
      //     name: "#[阴险]#",
      //     src: require("./emoji/yinxian.png"),
      //     nickname:'[恶魔]'
      //   },
      //   {
      //     name: "#[亲亲]#",
      //     src: require("./emoji/qinqin.png"),
      //     nickname:'[白眼]'
      //   },
      //   {
      //     name: "#[吓]#",
      //     src: require("./emoji/xia.png"),
      //     nickname:'[晕]'
      //   },
      //   {
      //     name: "#[可怜]#",
      //     src: require("./emoji/kelian.png"),
      //     nickname:'[嫌弃]'
      //   }
      // ]
    };
  },
  methods: {
    selectFun(name, img,nickname) {
      bus.$emit('EmotionsFun',name,img,nickname)
    }
  }
};
</script>

<style scoped>
#emtions {
   background-color: #fff;
  box-shadow: 0.0625rem 0.0625rem 0.0625rem 0.0625rem rgb(243, 243, 243);
  border-radius: 0.5rem;
  position: absolute;
  width: 35.5rem;
  height: 17.5rem;
  overflow: auto;
  z-index: 888;
  top: -17.5rem;
  left: 1rem;
}
#emtions ul {
  width: 92%;
  display: flex;
  margin: 0 auto;
  margin-top: 0.625rem /* 10/16 */;
  align-items: center;
  overflow: hidden;
  flex-wrap: wrap;
}
#emtions ul > li {
  margin: 0 0.8rem;
}
#emtions ul > li > img {
  width: 2rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/chatPlaza/emotions/emtion.vue